import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { RichTextEditor } from '@/components/editor/RichTextEditor';
import { cmsApi } from '@/lib/api';
import { toast } from 'sonner';
import { Loader2, Save } from 'lucide-react';

const AdminAboutPage = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [bodyHtml, setBodyHtml] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await cmsApi.getAbout();
        setBodyHtml(res.body_html || '');
      } catch (error) {
        console.error('Failed to load about content:', error);
        toast.error('Hakk\u0131nda i\u00e7eri\u011fi y\u00fcklenemedi');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await cmsApi.updateAbout({ body_html: bodyHtml });
      toast.success('Hakk\u0131nda i\u00e7eri\u011fi g\u00fcncellendi');
    } catch (error) {
      console.error('Failed to save about content:', error);
      toast.error('Hakk\u0131nda i\u00e7eri\u011fi kaydedilemedi');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-serif text-2xl font-bold text-foreground">Hakk\u0131nda Sayfas\u0131</h1>
          <p className="text-sm text-muted-foreground">
            Hakk\u0131nda sayfas\u0131n\u0131n t\u00fcm metin i\u00e7eri\u011fini buradan y\u00f6net.
          </p>
        </div>
        <Button onClick={handleSave} disabled={saving} className="bg-primary text-primary-foreground hover:bg-primary/90">
          <Save className="h-4 w-4 mr-2" />
          {saving ? 'Kaydediliyor...' : 'Kaydet'}
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>\u0130\u00e7erik</CardTitle>
        </CardHeader>
        <CardContent>
          <RichTextEditor
            content={bodyHtml}
            onChange={setBodyHtml}
            placeholder="Hakk\u0131nda sayfas\u0131 i\u00e7eri\u011fini yaz\u0131n..."
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminAboutPage;
